import React from 'react';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { KompisHyperlink } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes/lib';
import { useIntl } from 'react-intl';
import Box from 'ui/Box';
import Body from 'ui/Typography/Body';
import { isMobile } from 'utils/platform';
import SkapaSwitch from 'components/Switch/SkapaSwitch';

type Props = {
  toggleEnabled: boolean;
  toggleLabel: string;
  handleChange: () => void;
  onInfoTextClick: () => void;
  px: string;
};

const TopPanelWidgetBase = ({
  toggleEnabled,
  toggleLabel,
  handleChange,
  onInfoTextClick,
  px
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Box
        mb="1rem"
        px={px}
        mt={isMobile() ? 0 : '1rem'}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Body style={{ paddingRight: '1rem' }} type={ThemeFontStyleTypeEnum.bodyMedium}>
          {formatMessage({ id: toggleLabel })}
          <br />
          <KompisHyperlink
            theme={SkapaTheme}
            text={formatMessage({ id: 'storageone.platsaTopToggleQuestionLabel' })}
            onLinkClick={onInfoTextClick}
            underline
          />
        </Body>
        <SkapaSwitch
          id="toggle-toppanel"
          value={formatMessage({ id: toggleLabel })}
          label=""
          handleChange={handleChange}
          checked={toggleEnabled}
        />
      </Box>
    </>
  );
};

export default TopPanelWidgetBase;
